"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class ContentEditable extends React.Component {
    constructor(props) {
        super(props);
        this.htmlEl = undefined;
        this.lastHtml = undefined;
        this.emitChange = this.emitChange.bind(this);
        this.onPaste = this.onPaste.bind(this);
        this.placeCaretAtEnd = this.placeCaretAtEnd.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.onInput = this.onInput.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.handleTouchStart = this.handleTouchStart.bind(this);
    }
    shouldComponentUpdate(nextProps) {
        let { props, htmlEl } = this;
        if (!htmlEl) {
            return true;
        }
        if (document.activeElement === htmlEl) {
            return false;
        }
        if (nextProps.html !== htmlEl.innerHTML && nextProps.html !== props.html) {
            return true;
        }
        const optional = ['style', 'className', 'disable', 'tagName'];
        return optional.some(name => props[name] !== nextProps[name]);
    }
    componentDidUpdate() {
        const { html, id } = this.props;
        if (this.htmlEl && html !== this.htmlEl.innerHTML) {
            this.htmlEl.innerHTML = html;
        }
    }
    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyPress, false);
        this.placeCaretAtEnd(document.getElementById(this.props.id));
    }
    handleTouchStart(e) {
        this.emitChange(e, true);
    }
    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyPress, false);
    }
    handleKeyPress(e) {
        if (e.keyCode === 13) {
            this.props.onChange(this.htmlEl.innerText);
        }
    }
    placeCaretAtEnd(el) {
        if (typeof window.getSelection != 'undefined' && typeof document.createRange != 'undefined') {
            var range = document.createRange();
            range.selectNodeContents(el);
            range.collapse(false);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
            el.scrollLeft = el.offsetWidth;
        }
        else if (typeof el.createTextRange != 'undefined') {
            var textRange = el.createTextRange();
            textRange.moveToElementText(el);
            textRange.collapse(false);
            textRange.select();
        }
    }
    emitChange(evt, byPassTargetSet = false) {
        const { handleBlurChange, html, onChange, onBlurChange } = this.props;
        if (!this.htmlEl || !onBlurChange) {
            if (!byPassTargetSet) {
                evt.target = { value: html };
            }
            if (handleBlurChange) {
                handleBlurChange(html);
            }
            else {
                onChange(html);
            }
            return;
        }
        const { innerText } = this.htmlEl;
        if ((onChange || handleBlurChange) && this.htmlEl.innerText !== this.lastHtml) {
            if (!byPassTargetSet) {
                evt.target = { value: innerText };
            }
            if (handleBlurChange) {
                handleBlurChange(innerText);
            }
            else {
                onChange(innerText);
            }
        }
        this.lastHtml = innerText;
    }
    onInput(evt) {
        const { handlePlaceholderChange, onInputChange, inputType } = this.props;
        if (!this.htmlEl) {
            return;
        }
        const { innerText } = this.htmlEl;
        if (inputType === 'NUMBER') {
            if (innerText.trim() === '') {
                this.htmlEl.innerText = '';
            }
            else if (isNaN(innerText)) {
                let negativeNumber = false;
                if (innerText.charAt(0) === '-') {
                    negativeNumber = true;
                }
                const numsDots = innerText.replace(/[^0-9\.]/g, '').split('.');
                const validNumber = numsDots.shift() + (numsDots.length ? '.' + numsDots.join('') : '');
                const signedNumber = negativeNumber ? '-' + validNumber : validNumber;
                this.htmlEl.innerText = signedNumber;
                this.placeCaretAtEnd(document.getElementById(this.props.id));
            }
        }
        if (inputType === 'FIELD') {
            if (!innerText.match(/^[a-zA-Z_]\w*$/)) {
                const fieldString = innerText.replace(/^[^a-zA-Z_]*|[\W\s]*/g, '');
                this.htmlEl.innerText = fieldString;
                this.placeCaretAtEnd(document.getElementById(this.props.id));
            }
        }
        if (handlePlaceholderChange) {
            handlePlaceholderChange(innerText);
        }
        if (onInputChange) {
            onInputChange(innerText);
        }
    }
    onPaste(evt) {
        evt.preventDefault();
        var text = evt.clipboardData.getData('text');
        document.execCommand('insertText', false, text);
    }
    onFocus(evt) {
        if (!this.htmlEl) {
            return;
        }
        this.htmlEl.style.color = this.props.style.color || 'black';
    }
    render() {
        var _a = this.props, { html, id } = _a, props = __rest(_a, ["html", "id"]);
        return (React.createElement("div", { id: "contentEditableText" },
            React.createElement("style", { type: "text/css" }, `
                    [contenteditable]:focus {outline: 1px solid transparent;}
                    [contenteditable]::-webkit-scrollbar { 
                        display: none;
                    }
                `),
            React.createElement('div', {
                style: props.style,
                ref: (e) => (this.htmlEl = e),
                onInput: this.onInput,
                onBlur: this.emitChange,
                onPaste: this.onPaste,
                contentEditable: true,
                dangerouslySetInnerHTML: { __html: html },
                id: id,
                onFocus: this.onFocus,
            }, this.props.children)));
    }
}
exports.default = ContentEditable;
